import React from 'react'
import { Button } from 'antd'
import './style.scss'

class AppFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__bottom">
          <div className="row">
            <div className="col-sm-6">
              <p>
                <strong>Admnistrador Quqo-corbeta</strong>
              </p>
              <p>Compra y Vende todos tus productos en un solo lugar</p>
            </div>
            <div className="col-sm-6">
              <div className="footer__copyright">
                <img
                  src="resources/quqoImages/logoQ.png"
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="Mediatec Software"
                />
                <span>
                  © 2019 <a>Quqo</a>
                  <br />
                  Administrador
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppFooter



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Footer/index.js